module.exports = __webpack_public_path__ + "img/tlbc.1623d2e0.png";